/**
 * Query Logging on Public Pages.
 */
// eslint-disable-next-line no-unused-vars
class QueryLog {
    constructor({
        qlog_id = 0,
        group_id = 0,
        query = '',
    }) {
        this.qlog_id = qlog_id;
        this.group_id = group_id;
        this.first_search_saved = this.qlog_id > 0 ? true : false;
        this.query = query;
    }

    /**
     * Record a new entry or update the search.
     * @param {String} query Search text
     * @param {String} refer Optional referrer
     */
    record({
        query = '',
        refer = '',
    }) {
        if (this.first_search_saved) {
            this.first_search_saved = false;
            if (this.query === query) {
                return;
            }
        }
        if (!query || this.query === query) {
            return;
        }
        if (!refer) {
            refer = location.href;
        }

        jQuery.ajax({
            method: 'POST',
            url: '/search/log',
            data: {
                qlog: this.qlog_id,
                refer: refer,
                group_id: this.group_id,
                query: query,
            },
            dataType: 'json',
        })
            .done((d) => {
                if (d.qlog_id) {
                    this.qlog_id = d.qlog_id;
                }
            });
    }

    /**
     * Record that user is going to a specific FAQ.
     * @param {Int} data.faqid target FAQ id
     */
    gotoFAQ({
        faqid = 0,
    }) {
        if (faqid <= 0) {
            return;
        }
        jQuery.ajax({
            method: 'POST',
            url: '/search/log/clicked',
            data: {
                faqid: faqid,
                qlog: this.qlog_id,
            },
        });
        // we don't care about any return.
    }
}
